// @flow
import Debug from 'debug';
import { makeIconStyle, makeLabelStyle, makeDraggableLabelStyle, makeLabelConnectorStyle } from '../style';

const iconCache = {};
const makePlaneIcon = (color: string) => {
    if(iconCache[color]) {
        return iconCache[color];
    }
    else {
        const icon = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='${color ? encodeURIComponent(color) : '%23fff'}' d='M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' /%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E`;
        iconCache[color] = icon;
        return icon;
    }

};

const debug = Debug('amms:modules:map:plane');

const SCALE = 1;

const systemStyle = {
    icon: makeIconStyle(makePlaneIcon('#3872F4'), SCALE),
    label: makeLabelStyle('#020303', '#51E3C2')
};
const selectedSystemStyle = {
    icon: makeIconStyle(makePlaneIcon('#020ceb'), SCALE * 1.2),
    label: makeLabelStyle('#ffffff', '#020ceb')
};
export const targetStyles = {
    default: {
        system: systemStyle
    },
    selected: {
        system: selectedSystemStyle
    }
};

const systemDraggableLabel = makeDraggableLabelStyle('#ffffff', '#3872F4');
export const draggableLabelStyles = {
    default: {
        system: systemDraggableLabel
    },
    selected: {
        system: systemDraggableLabel
    }
};

const systemLabelConnector = makeLabelConnectorStyle('#3872F4');
export const labelConnectorStyles = {
    default: {
        system: systemLabelConnector
    },
    selected: {
        system: systemLabelConnector
    }
};